// import route file
import AppRoutes from "./routes/Index";

const App = () => {
    return (
        <>
            <AppRoutes />
        </>
    );
}

export default App;